/* ODDAY global helpers: toast, cart add, wishlist, rails, reveal, confetti */
(() => {
  if (window.ODD) return;
  const ODD = (window.ODD = {});

  /* ---------- toast ---------- */
  let toastEl, tt;
  ODD.toast = (msg) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'odd-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.innerHTML = '<i></i><span></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('span').textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(tt);
    tt = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  };

  /* ---------- cart add (works with Dawn's cart drawer) ---------- */
  ODD.addToCart = async ({ id, quantity = 1, properties = {} }) => {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items: [{ id: Number(id), quantity, properties }] };
    if (cart) {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    const res = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (data.status) {
      ODD.toast(data.description || data.message || 'Could not add to bag');
      throw data;
    }
    if (cart && typeof cart.renderContents === 'function') {
      /* /cart/add.js with items[] returns {items:[...], sections:{...}} */
      const state = data.items ? { ...data.items[0], sections: data.sections } : data;
      cart.classList.contains('is-empty') && cart.classList.remove('is-empty');
      cart.renderContents(state);
    } else {
      window.location.href = window.routes?.cart_url || '/cart';
    }
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'odday', productVariantId: id });
    }
    return data;
  };

  /* ---------- delegated clicks ---------- */
  const WKEY = 'odd-wishlist';
  const readW = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } };
  const writeW = (a) => { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} };
  const paintW = () => { const w = readW(); document.querySelectorAll('[data-wish]').forEach((b) => b.classList.toggle('is-on', w.includes(b.dataset.wish))); };
  document.addEventListener('DOMContentLoaded', paintW);
  document.addEventListener('shopify:section:load', paintW);

  document.addEventListener('click', async (e) => {
    const w = e.target.closest('[data-wish]');
    if (w) {
      e.preventDefault();
      let a = readW();
      const h = w.dataset.wish;
      a = a.includes(h) ? a.filter((x) => x !== h) : [...a, h];
      writeW(a);
      paintW();
      ODD.toast(a.includes(h) ? 'Saved to your wishlist' : 'Removed from wishlist');
      return;
    }
    const toggle = e.target.closest('[data-card-atc-toggle]');
    if (toggle) {
      e.preventDefault();
      const wrap = toggle.closest('[data-card-sizes]');
      const sizes = wrap?.querySelector('.opc-card-sizes');
      if (sizes) {
        const isHidden = sizes.hidden;
        sizes.hidden = !isHidden;
        toggle.style.display = isHidden ? 'none' : '';
      }
      return;
    }
    const q = e.target.closest('[data-quick-add]');
    if (q) {
      e.preventDefault();
      q.classList.add('is-loading');
      try {
        await ODD.addToCart({ id: q.dataset.quickAdd });
        ODD.toast('Added to your bag! ✦');
        const wrap = q.closest('[data-card-sizes]');
        if (wrap) {
          const sizes = wrap.querySelector('.opc-card-sizes');
          const toggle = wrap.querySelector('[data-card-atc-toggle]');
          if (sizes) sizes.hidden = true;
          if (toggle) toggle.style.display = '';
        }
      } catch (err) {}
      q.classList.remove('is-loading');
    }
  });

  /* ---------- reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.12 })
    : null;
  const watch = (root = document) => root.querySelectorAll('.odd-reveal:not(.is-in)').forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));
  document.addEventListener('DOMContentLoaded', () => watch());
  document.addEventListener('shopify:section:load', (e) => watch(e.target));
  if (window.Shopify && Shopify.designMode) document.documentElement.classList.add('odd-design-mode');

  /* ---------- confetti ---------- */
  ODD.confetti = () => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const c = document.createElement('canvas');
    c.className = 'odd-confetti';
    document.body.appendChild(c);
    const x = c.getContext('2d');
    c.width = innerWidth; c.height = innerHeight;
    const cols = ['#360403', '#711109', '#BB2921', '#57BCBE', '#377E7E', '#F6C744'];
    const ps = Array.from({ length: 170 }, () => ({ x: innerWidth / 2 + (Math.random() - 0.5) * 200, y: innerHeight * 0.45, vx: (Math.random() - 0.5) * 16, vy: -Math.random() * 16 - 4, r: Math.random() * 7 + 4, c: cols[(Math.random() * cols.length) | 0], a: Math.random() * 6, s: Math.random() < 0.5 }));
    let f = 0;
    (function tick() {
      x.clearRect(0, 0, c.width, c.height);
      ps.forEach((p) => { p.vy += 0.42; p.vx *= 0.99; p.x += p.vx; p.y += p.vy; p.a += 0.15; x.save(); x.translate(p.x, p.y); x.rotate(p.a); x.fillStyle = p.c; if (p.s) x.fillRect(-p.r / 2, -p.r / 4, p.r, p.r / 2); else { x.beginPath(); x.arc(0, 0, p.r / 2.2, 0, 7); x.fill(); } x.restore(); });
      if (++f < 170) requestAnimationFrame(tick); else c.remove();
    })();
  };

  /* ---------- draggable rail ---------- */
  if (!customElements.get('odday-rail')) {
    class OddayRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rail-track]');
        if (!this.track) return;
        const step = () => (this.track.firstElementChild?.offsetWidth || 300) + 20;
        this.querySelector('[data-rail-prev]')?.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        this.querySelector('[data-rail-next]')?.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
        const bar = this.querySelector('[data-rail-progress]');
        if (bar) {
          const u = () => {
            const max = this.track.scrollWidth - this.track.clientWidth;
            const w = this.track.clientWidth / this.track.scrollWidth;
            bar.style.width = Math.min(100, w * 100) + '%';
            bar.style.transform = `translateX(${(max ? this.track.scrollLeft / max : 0) * (1 / w - 1) * 100}%)`;
          };
          this.track.addEventListener('scroll', u, { passive: true });
          addEventListener('resize', u);
          u();
        }
        let down = false, sx = 0, sl = 0, moved = false;
        this.track.addEventListener('mousedown', (e) => { down = true; moved = false; sx = e.pageX; sl = this.track.scrollLeft; });
        addEventListener('mouseup', () => { down = false; this.track.classList.remove('is-drag'); });
        this.track.addEventListener('mousemove', (e) => {
          if (!down) return;
          const d = e.pageX - sx;
          if (Math.abs(d) > 5) { moved = true; this.track.classList.add('is-drag'); }
          this.track.scrollLeft = sl - d;
        });
        this.track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
        this.track.addEventListener('dragstart', (e) => e.preventDefault());
      }
    }
    customElements.define('odday-rail', OddayRail);
  }
})();
